const initialState = {
  conversations: [],
  getConversationsPending: false,
  getConversationsError: null,
  messages: [],
  conversationId: null,
  generateVibeResponsePending: false,
  generateVibeResponseError: null,
  getConversationHistoryPending: false,
  getConversationHistoryMorePending: false,
  getConversationHistoryError: null,
  conversationHistoryHasMore: false,
  conversationHistoryBefore: null,
  runEvents: [],
  runResult: null,
  streamingMessage: '',
  activeArtifact: null,
  toolCalls: [],
  clearConversationHistoryPending: false,
  clearConversationHistoryError: null,
  workspace: null,
  workspacePending: false,
  workspaceError: null,
  workspaceSaveError: null,
  workspaceFiles: {},
  workspaceSelectedPath: null,
  workspaceFile: null,
  workspaceFilePending: false,
  workspaceSavePending: false,
  workspaceConflict: false,
  budget: null,
  stoppedInfo: null,
  isResumable: false,
  currentPhase: null,
  runMetadata: null,
  verificationResult: null,
  activeStreamRequestId: null,
  activeContextId: null,
  activeHistoryRequestId: null,
  activeConversationsRequestId: null,
  activeWorkspaceRequestId: null,
  planPending: false,
  planError: null,
  planProposal: null,
  milestones: [],
  lastEventSequence: 0,
  previewFilesLoading: false,
  previewFilesError: '',
  previewFiles: [],
  loadingFileChange: false,
  fileChangeError: null,
};

export default initialState;
